import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation, Trans } from 'react-i18next';

import { api } from '../../../lib/api';
import Text from '../../../shared/Text';
import { Button } from '../../../shared/FormStyles/Button';
import FlagIcon from '../../../shared/FlagIcon/index.jsx';

const LanguagePrompt = ({ languageCode, closePrompt, languageName }) => {
  const { t } = useTranslation(['header', 'shared', 'translationModal']);

  const changeLanguages = () => {
    api({
      method: 'patch',
      url: '/api/language_settings/update_language',
      data: { language: languageCode },
    }).then(() => location.reload());
  };

  return (
    <>
      <MobileOverlay></MobileOverlay>
      <Wrapper>
        <IconSide>
          <LanguageIcon />
        </IconSide>
        <Section>
          <CloseIcon onClick={() => closePrompt()} />
          <Text variant="button" mb="4px">
            {t('header:languagePrompt.title')}
          </Text>
          <Text variant="small3">{t('header:languagePrompt.body')}</Text>
          <FlagWrapper>
            <FlagIcon code={languageCode} />
            <Text ml="7px" variant="body2">
              {languageName}
            </Text>
          </FlagWrapper>
          <Text variant="small5" fontStyle="italic" as="p" my="1em">
            <Trans i18nKey="translationModal" t={t} components={{ a: <a /> }}>
              {t('translationModal:disclaimer')}
            </Trans>
          </Text>
          <div>
            <Button
              onClick={() => changeLanguages()}
              padding="8px 25px"
              variant="containedGreen"
              mr="8px"
            >
              {t('shared:yes')}
            </Button>
            <Button
              onClick={() => closePrompt()}
              padding="8px 25px"
              variant="outlinedRed"
            >
              {t('shared:no')}
            </Button>
          </div>
        </Section>
      </Wrapper>
    </>
  );
};

export default LanguagePrompt;

const MobileOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  top: 0;
  left: 0;
  ${themeGet('mediaQueries.forMediumUp')} {
    display: none;
  }
`;

const Wrapper = styled.div`
  width: 325px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(37, 40, 43, 0.14);
  position: absolute;
  top: 92px;
  right: 15px;
  z-index: 999;
  background-color: ${themeGet('colors.white')};
  display: flex;
`;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  padding: 16px;
  position: relative;
`;

const FlagWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 6px 0;
`;

const IconSide = styled.div`
  width: 48px;
  background-color: ${themeGet('colors.primary.100')};
  border-radius: 8px 0 0 8px;
  display: flex;
  align-items: center;
`;

const LanguageIcon = styled.i`
  color: ${themeGet('colors.white')};
  width: 48px;
  height: 48px;
  padding-left: 4px;
`;

LanguageIcon.defaultProps = {
  className: 'fa-regular fa-language fa-2x',
};

const CloseIcon = styled.i`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;

  color: ${themeGet('colors.black.100')};
`;

CloseIcon.defaultProps = {
  className: 'fa-regular fa-xmark',
};
